<template>
  <modal :opened="opened">
    <div class="container-fluid">
      <h6 class="font-weight-bold text-center border-bottom pb-3 mb-0">Como deseja reimprimir?</h6>
      <div v-if="loading" class="py-5">
        <loading/>
      </div>
      <div v-if="!loading && !regras.length" class="my-3">
        <label class="mb-0 d-block mb-3">
          <input :checked="destinoComprovante" class="mr-1" type="checkbox" @change="toggleDestinoComprovante()">
          Reimprimir comprovante
          <span class="small text-muted d-block">Impressora: comprovante padrão</span>
        </label>
      </div>
      <div v-for="regra in regras" v-if="!loading && regras.length" :key="regra.id_impressao_regra" class="my-3">
        <label class="mb-0 d-block mb-3">
          <input :checked="regrasSelecionadas.includes(regra.id_impressao_regra)" class="mr-1" type="checkbox" @change="toggleRegraImpressao(regra.id_impressao_regra)">
          {{ regra.nome_regra }}
          <span class="small text-muted d-block">Impressora: {{ regra.impressora_descricao }}</span>
        </label>
      </div>
      <div v-if="!loading && !regras.length" class="small text-muted mb-3">
        Nenhuma regra de impressão disponível para este pedido.
      </div>
      <div class="border-top pt-3 text-center d-flex justify-content-between">
        <button class="btn btn-light border p-3 " @click="fecharModal()"><i class="fa fa-angle-left"></i> Voltar</button>
        <button :disabled="(!destinoComprovante && !regrasSelecionadas.length) || loading" class="btn btn-success p-3" @click="confirmar()">
          Reimprimir
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from './ModalGestor';
import Loading from './loading';

export default {
  name: 'ModalReimpressaoDelivery',
  components: {
    Modal,
    Loading
  },
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    regras: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      destinoComprovante: false,
      regrasSelecionadas: []
    };
  },
  watch: {
    opened(value) {
      if (value) {
        this.resetarSelecao();
      } else {
        this.limparSelecao();
      }
    },
    regras() {
      if (this.opened) {
        this.resetarSelecao();
      }
    }
  },
  methods: {
    resetarSelecao() {
      this.destinoComprovante = false;
      this.regrasSelecionadas = this.regras.map((regra) => regra.id_impressao_regra);
    },
    limparSelecao() {
      this.destinoComprovante = false;
      this.regrasSelecionadas = [];
    },
    fecharModal() {
      this.limparSelecao();
      this.$emit('close');
    },
    confirmar() {
      this.$emit('confirm', this.destinoComprovante
        ? { destino: 'comprovante', qtd_copias: 1 }
        : { regras: this.regrasSelecionadas, qtd_copias: 1 });
      this.limparSelecao();
    },
    toggleDestinoComprovante() {
      this.destinoComprovante = !this.destinoComprovante;

      if (this.destinoComprovante) {
        this.regrasSelecionadas = [];
      }
    },
    toggleRegraImpressao(idRegra) {
      this.destinoComprovante = false;

      if (this.regrasSelecionadas.includes(idRegra)) {
        this.regrasSelecionadas = this.regrasSelecionadas.filter((id) => id !== idRegra);
      } else {
        this.regrasSelecionadas = [...this.regrasSelecionadas, idRegra];
      }
    }
  }
};
</script>
